import React from 'react';
import {Link} from 'react-router-dom'
import SignIn from './SignIn'
import {Context} from '../Context'

import './LandingPage.css'

const LandingPage = () =>
<div className="landing-page">
  <Context.Consumer>
    { ({globalState, actions}) =>
      <React.Fragment>
        <div className="landing-page-block">
          <img src="../images/logo.png" />
          BETA TESTING

          <SignIn />

          <a href='https://firebasestorage.googleapis.com/v0/b/wendoeapp.appspot.com/o/privacy.html?alt=media&token=9838e3c1-c466-4c25-a8ca-25f4e96df5bd' target='_blank'>Privacy</a>
        </div>
      </React.Fragment>
    }
  </Context.Consumer>
</div>


export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/LandingPage.js